import { Helmet } from 'react-helmet/es/Helmet'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { TableBottomPaginationBlock } from '../../components/Common/Table'
import {
  Button,
  message,
  Pagination,
  Popconfirm,
  Tooltip,
  Space,
  Col,
  Row,
  Input,
} from 'antd'
import uuid from 'uuid'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import {
  DeleteOutlined,
  QuestionCircleOutlined,
  CloseCircleOutlined,
  FilterOutlined,
} from '@ant-design/icons'
import PageTitle from '../../components/PageTitle'
import AppPageHeader from '../../components/AppPageHeader'
import { inject, observer } from 'mobx-react'
import signAccountStore from '../../stores/signAccountStore'
import EditSignAccountModal from './EditSignAccountModal/EditSignAccountModal'
import TableComponent from '../../components/Common/TableComponent'
import { ACL_ACTION_TYPE } from '../../constants'
import AccessControlAction from '../../components/AccessControlAction/AccessControlAction'
import {
  FilterButton,
  SearchBar,
} from '../UserAccountManagementPage/UserAcountManagementPageStyled'
import AdvanceFilter from './AdvanceFilter'
import {
  AddCircleOutlineIcon,
  TrashBin2OutlineIcon,
} from '../../components/AppIcon'
import SignAccountPageAddvanceFilterV2 from './SignAccountPageAddvanceFilterV2'
import { AppTable } from '../../components/AppTable/AppTable'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'

const { Search } = Input
const SignAccountPage = props => {
  const { loadingAnimationStore, signAccountStore, history, aclStore } = props

  const { list, totalCount, filter, setFilter } = signAccountStore
  const [isVisibleModal, setIsVisibleModal] = useState(false)

  useEffect(() => {
    load()
    return () => signAccountStore.clear()
  }, [signAccountStore])
  useEffect(() => {
    load()
  }, [filter])
  function load() {
    loadingAnimationStore.showSpinner(true)

    signAccountStore
      .getList(filter.page, filter.size)
      .then(() => {})
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  const onChangeTable = useCallback(
    (current, size) => {
      if (size !== filter.size) {
        filter.page = 1
        filter.size = size
      } else {
        filter.page = current
      }
      signAccountStore.setFilter(filter)
      load()
    },
    [signAccountStore, filter]
  )

  const handleCloseModal = () => {
    setIsVisibleModal(false)
    signAccountStore.clearDetails()
  }

  const handleDelete = async record => {
    try {
      loadingAnimationStore.showSpinner(true)
      await signAccountStore.delete(record)
      load()
    } catch (error) {
      message.error(error.vi)
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const onItemClick = record => {
    // console.log('record', toJS(record))
    signAccountStore.signAccountDetails = record
    setIsVisibleModal(true)
  }

  const tableColumn = [
    // {
    //   title: 'Nhà cung cấp',
    //   render: record => record?.provider,
    //   onCell: record => {
    //     return {
    //       onClick: () => onItemClick(record),
    //     }
    //   },
    // },
    {
      title: 'Người dùng',
      width: 200,
      render: record => record?.user_name,
      onCell: record => {
        return {
          onClick: () => onItemClick(record),
        }
      },
    },
    {
      title: 'Tài khoản',
      width: 200,
      render: record => record?.account,
      onCell: record => {
        return {
          onClick: () => onItemClick(record),
        }
      },
    },
    {
      title: 'Loại',
      width: 100,
      render: record => record?.type,
      onCell: record => {
        return {
          onClick: () => onItemClick(record),
        }
      },
    },
    ...(aclStore.checkAccessControlAction(
      ACL_ACTION_TYPE.delete__TAI_KHOAN_KY_SO
    )
      ? [
          {
            title: 'Tác vụ',
            width: 100,
            align: 'center',
            render: record => (
              <>
                <AccessControlAction
                  aclActionType={ACL_ACTION_TYPE.delete__TAI_KHOAN_KY_SO}>
                  <Tooltip title={'Xóa'}>
                    <Popconfirm
                      onConfirm={() => {
                        handleDelete(record)
                      }}
                      okText={'Đồng ý'}
                      cancelText={'Không'}
                      okType={'danger'}
                      icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                      title={'Bạn có muốn xoá tài khoản này?'}>
                      <TrashBin2OutlineIcon
                        style={{ color: '#fc0000', width: 16, height: 16 }}
                      />
                    </Popconfirm>
                  </Tooltip>
                </AccessControlAction>
              </>
            ),
          },
        ]
      : []),
  ]
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)

  return (
    <DashboardLayout>
      <Helmet>
        <title>Tài khoản ký số</title>
      </Helmet>

      <AppPageHeader
        title="Tài khoản ký số"
        addon={
          <>
            <SignAccountPageAddvanceFilterV2
              filter={filter}
              setFilter={setFilter}
            />
            <AccessControlAction
              aclActionType={ACL_ACTION_TYPE.create__TAI_KHOAN_KY_SO}>
              <Button
                className="custom-ant-button icon-btn"
                icon={
                  <AddCircleOutlineIcon
                    style={{ color: '#fff', width: 16, height: 16 }}
                  />
                }
                type={'primary'}
                onClick={() => {
                  signAccountStore.clearDetails()
                  setIsVisibleModal(true)
                }}>
                Tạo tài khoản
              </Button>
            </AccessControlAction>
          </>
        }
      />

      <ContentBlockWrapper>
        <AppTable
          // onRow={record => {
          //   return {
          //     onClick: () => {
          //       // console.log('record', toJS(record))
          //       signAccountStore.signAccountDetails = record
          //       setIsVisibleModal(true)
          //     },
          //   }
          // }}
          rowKey={() => uuid()}
          columns={tableColumn}
          dataSource={list}
          pagination={false}
          // onChange={onChangeTable}
        />

        <AppTablePagination
          current={filter.page}
          pageSize={filter.size}
          total={totalCount}
          onChange={onChangeTable}
          showSizeChanger={false}
          showLessItems
          showQuickJumper={false}
        />

        <EditSignAccountModal
          isVisibleModal={isVisibleModal}
          handleCloseModal={handleCloseModal}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

SignAccountPage.propTypes = {}

export default memo(
  inject(
    'loadingAnimationStore',
    'signAccountStore',
    'aclStore'
  )(observer(SignAccountPage))
)
